/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Добавление товаров в корзину по артикулу
   */
  app.CartAddByArticul = app.View.extend({
    el: '.js-cart-add-by-articul',

    events: {
      'click .js-add-by-article': 'addInCart',
      'click .js-reset-to-form': 'renderFirstPopupInner',
      'click .js-popup-close': 'closePopup',
      'keydown .js-textarea': 'checkHotkey',
    },

    run: function (options) {
      if (options && options.cart) {
        _.extend(this, options);
      }
      this.firstInnerTemplate = app.helpers.TemplateHelper.getTemplate('#article-popup-inner-1');
      this.secondInnerTemplate = app.helpers.TemplateHelper.getTemplate('#article-popup-inner-2');
      this.popup = new als.Popup($('.popup-art'), $('.opener-art'));
      this.popup.addEventListener(als.Popup.EventType.BEFORE_OPEN, function (e, data) {
        app.recommendationsEvents.trigger('openAddByArticulForm');
        var popup = $('.popup-art');
        var target = data.target;
        var top = target.offset().top + target.outerHeight();
        if (target.offset()) {
          popup.css({top: top});
        } else {
          popup.css({top: '40%'});
        }
        if (target.hasClass('js-opener-art')) {
          popup.addClass('popup-art_left');
        } else {
          popup.removeClass('popup-art_left');
        }
      });
      this.listenTo(this.cart, 'addedCartByArticle', this.renderSecondPopupInner);
      this.listenTo(this.cart, 'addedCartByArticle', this.pushData);
      this.listenTo(this.cart, 'pushAddedByArticleToDataLayer', this.collectData);
    },

    /**
     * Вызывает массовое добавление в корзину, используя список артикулов из текстового поля попапа.
     */
    addInCart: function () {
      var sids = this.$('textarea').val();
      this.dataQuantities = [];
      this.dataSids = [];
      this.dataPrices = [];
      if (sids.length) {
        this.$('button').prop('disabled', true);
        this.cart.addByArticul(sids);
      }

      // сообщаем в рекомендации о нажатии кнопки
      app.recommendationsEvents.trigger('addInCartByArticul');
    },
    /**
     * Отправляем данные в DataLayer
     */
    pushData: function () {
      dataLayer.push({
        event: 'massive_add',
        sids: this.dataSids,
        quantities: this.dataQuantities,
        prices: this.dataPrices
      });
    },
    /**
     * Собираем данные для DataLayer
     * @param model
     */
    collectData: function (model) {
      this.dataQuantities.push(model.qty);
      this.dataSids.push(model.item_sid);
      this.dataPrices.push(model.price);
    },
    /**
     * Рисует второй вид попапа с отчетом о добавлении товаров в корзину
     * @param {Object} data ответ после добавления
     * @param {Object[]|string[]} artList список артикулов
     */
    renderSecondPopupInner: function (data, artList) {
      var items = artList.map(function (item) {
        var itemFromReport = _.find(data.report, {
          item_sid: _.isObject(item) ? item.item_sid : item
        });
        return itemFromReport ? itemFromReport : item;
      });
      this.$('.article-popup-inner').html(
        this.secondInnerTemplate({items: items})
      );
    },

    /**
     * Рисует первоначальный вид попапа.
     */
    renderFirstPopupInner: function () {
      this.$('.article-popup-inner').html(this.firstInnerTemplate());
    },

    /**
     * Закрывает попап.
     */
    closePopup: function () {
      this.popup.close();
    },

    /**
     * Добавляет в корзину, если нажаты горячие клавиши.
     */
    checkHotkey: function(keyboardEvent) {
      if(keyboardEvent
        && keyboardEvent.ctrlKey
        && keyboardEvent.keyCode === app.KEY_CODES.Enter) {
        this.addInCart();
      }
    },
  });

})(jQuery);

}.call(window));